"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
function useIsTablet() {
    var theme = core_1.useTheme();
    return core_1.useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));
}
exports.default = useIsTablet;
